/* eslint-disable complexity */
import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import StoreDataContext from "src/app/context/store-data";
import Main from "src/app/components/Main/Main";
import Aside from "src/app/components/Aside/Aside";
import Card from "src/app/components/Card/Card";
import ViewRelatedQuestions from "src/app/components/ViewRelatedQuestions/ViewRelatedQuestions";
import getQueryParamValue from "src/utilities/getQueryParamValue";

import { SierraChat } from "src/app/components/SierraChat/SierraChat";
import SierraChatButton from "src/app/components/SierraChatButton/SierraChatButton";
import HeroSection from "./HeroSection";
import useOutOfHours from "../../hooks/useOutOfHours";
import { isWebView } from "../../../utilities/isWebView";
import OutOfHoursInfoMessage from "src/app/components/OutOfHoursInfoMessage";

export default function GetInTouch({ content }) {
  const [hasMounted, setHasMounted] = useState(false);
  const [webView, setWebView] = useState(false);
  const [showSierraChat, setShowSierraChat] = useState(() => {
    return getQueryParamValue("showChatWidget") === "true" || false;
  });
  const [sierraLoadError, setSierraLoadError] = useState(null);

  const { storeCode, countryCode } = useContext(StoreDataContext);
  const { outOfHours } = useOutOfHours({ storeCode, countryCode });

  const aside = content?.aside;
  const popularArticles = aside?.["popular-articles"]?.elements[0];

  const isOutOfHours = outOfHours && outOfHours !== false;

  useEffect(() => {
    setWebView(isWebView());
    setHasMounted(true);
  }, []);

  useEffect(() => {
    if (isOutOfHours && showSierraChat) {
      setShowSierraChat(false);
    }
  }, [isOutOfHours, showSierraChat]);

  if (!hasMounted) return null;

  return (
    <>
      <Main>
        {showSierraChat && !isOutOfHours ? (
          <SierraChat
            setShow={setShowSierraChat}
            setLoadError={setSierraLoadError}
          />
        ) : (
          <Card
            type="getInTouch"
            ariaLive="polite"
            ariaRelevant="additions text"
          >
            <HeroSection body={content?.main?.body} />
            {isOutOfHours ? (
              <OutOfHoursInfoMessage
                openingTimes={outOfHours.nextOpeningHour}
                countryCode={countryCode}
              />
            ) : (
              <SierraChatButton
                sierraLoadError={sierraLoadError}
                isWebView={webView}
                onStartChat={() => setShowSierraChat(true)}
              />
            )}
          </Card>
        )}
      </Main>
      <Aside>
        <Card type="aside">
          <ViewRelatedQuestions
            data={popularArticles}
            showButton={false}
            visibleItems={6}
          />
        </Card>
      </Aside>
    </>
  );
}

GetInTouch.propTypes = {
  content: PropTypes.object,
};
